

//import react
import React from 'react';
//create context

export const GameStateContext = React.createContext(null);
